<template>
  <v-container class="mt-0 pt-0" fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12 class="px-0 py-0">
        <v-card title="Impact Buyers" offset="0">
          <v-toolbar dense color="#4cc7e8" dark class="pb-0 mb-0">
            Lead For ($)
            <v-spacer></v-spacer>
            <v-btn @click="expandedFilters = !expandedFilters" flat>
              <span v-if="expandedFilters">Hide Filters</span>
              <span v-if="!expandedFilters">Show Filters</span>
            </v-btn>
            <v-btn flat @click="resetFilters()">Clear Grid Filters</v-btn>
            <v-btn
              color="success"
              small
              @click="createLinks"
              :loading="createLeadsLoading"
              >Create Leads for Selected</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <!-- FILTERS -->
            <v-slide-y-transition>
              <v-layout row wrap v-if="expandedFilters">
                <v-flex xs4 class="py-0 px-2">
                  <v-text-field
                    v-model="search"
                    v-on:input="onQuickFilterChanged"
                    label="Search"
                    prepend-icon="mdi-magnify"
                    hide-details
                    clearable
                    height="40"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="py-0 px-2">
                  <v-select
                    v-model="agGridFilter.membershipYearFilter"
                    label="Membership Year Filter"
                    @change="updateFilter"
                    :items="yearFilterArray"
                    height="40"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="py-0 px-2">
                  <v-autocomplete
                    v-model="agGridFilter.statusFilter"
                    label="Status Filter"
                    small-chips
                    multiple
                    clearable
                    hide-details
                    :items="statusList"
                    @change="updateFilter"
                    height="40"
                  >
                    <template #selection="{ item }">
                      <v-chip
                        class="pr-0"
                        color="#4cc7e8"
                        style="color: white; font-weight: bold"
                        small
                        >{{ item }}
                        <v-icon
                          color="white"
                          @click="removeStatus(item)"
                          style="
                            font-size: 12pt;
                            margin-right: -8px;
                            margin-left: 2px;
                          "
                          >mdi-close</v-icon
                        >
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    v-model="agGridFilter.categoryFilter"
                    label="Category Filter"
                    small-chips
                    multiple
                    clearable
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    @change="updateFilter"
                  >
                    <template #selection="{ item }">
                      <v-chip
                        class="pr-0"
                        color="#4cc7e8"
                        style="color: white; font-weight: bold"
                        small
                        >{{ item.name }}
                        <v-icon
                          color="white"
                          @click="removeCategory(item)"
                          style="
                            font-size: 12pt;
                            margin-right: -8px;
                            margin-left: 2px;
                          "
                          >mdi-close</v-icon
                        >
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    v-model="agGridFilter.subCategoryFilter"
                    label="Sub Category Filter"
                    small-chips
                    multiple
                    clearable
                    :items="subCategories"
                    item-text="name"
                    item-value="id"
                    @change="updateFilter"
                  >
                    <template #selection="{ item }">
                      <v-chip
                        class="pr-0"
                        color="#4cc7e8"
                        style="color: white; font-weight: bold"
                        small
                        >{{ item.name }}
                        <v-icon
                          color="white"
                          @click="removeSubCategory(item)"
                          style="
                            font-size: 12pt;
                            margin-right: -8px;
                            margin-left: 2px;
                          "
                          >mdi-close</v-icon
                        >
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-slide-y-transition>

            <v-layout row wrap>
              <v-flex xs-12 class="py-0">
                <ag-grid-vue
                  :style="{ width, height }"
                  class="ag-theme-alpine"
                  :defaultColDef="defaultColDef"
                  :columnDefs="columnDefs"
                  :rowData="rowData"
                  :animateRows="true"
                  :rowBuffer="5"
                  :pagination="true"
                  :isExternalFilterPresent="isExternalFilterPresent"
                  :doesExternalFilterPass="doesExternalFilterPass"
                  rowSelection="multiple"
                  :rowDeselection="true"
                  @grid-ready="onGridReady"
                ></ag-grid-vue>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import moment from "moment";
import { AgGridVue } from "ag-grid-vue";

export default {
  props: ["business_id", "lockedData"],
  components: {
    AgGridVue,
  },
  data: () => ({
    //AG-Grid
    columnDefs: null,
    rowData: null,
    columnApi: null,
    gridApi: null,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      autoHeight: true,
      filterParams: { newRowsAction: "keep" },
    },
    width: "100%",
    height: "calc(100vh - 440px)",
    search: "",
    searchDebounce: null,
    agGridFilter: {
      membershipYearFilter: "All",
      categoryFilter: [],
      subCategoryFilter: [],
      statusFilter: ["Approved & Live"],
    },

    statusList: [
      "Admin",
      "Prospecting",
      "Drafting",
      "Approved & Live",
      "Paused / Live",
      "Left & Removed",
    ],

    yearFilterArray: ["All"],
    interestedStatusList: ["Prospecting", "Open", "Not Interested"],

    // Buyer Type List
    buyerTypeList: [
      "Church",
      "Charity",
      "Social Enterprise",
      "School",
      "Pre-School",
      "Self Employed",
      "Small Service Business ( 2 - 20 )",
      "Medium Service Business ( 20 - 50 )",
      "Large Company ( 50 + )",
      "Physical Shop",
      "Online Store",
      "Farm",
      "Mall",
      "MP Office",
      "Small Corporate ( Based Regionally )",
      "Large Corporate ( Based Nationally )",
      "Local Government ( District Entity )",
      "Government ( National Entity )",
    ],

    expandedFilters: true,
    saving: false,
    createLeadsLoading: false,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      leadForData: "leads/leadForGridData",
      aGGridActionMenu: "agGrid/aGGridActionMenu",
      selectedRowData: "agGrid/selectedRowData",
      goodCauses: "goodCauses/listOrderedByCategories",
      categories: "categories/list",
      subCategories: "categories/subCategoryList",
    }),
  },
  watch: {
    leadForData: function() {
      if (this.gridApi != null) {
        this.gridApi.showLoadingOverlay();
        this.setGridData(this.leadForData);
      }
    },
    expandedFilters: function() {
      if (this.expandedFilters == true) {
        this.height = "calc(100vh - 440px)";
      } else {
        this.height = "calc(100vh - 320px)";
      }
    },
    business_id: function() {
      if (this.business_id != undefined) {
        this.gridApi.showLoadingOverlay();

        this.$store
          .dispatch("leads/loadLeadForGridData", this.business_id)
          .then(() => {
            this.setGridData(this.leadForData);
          });
      } else {
        if (this.gridApi != null) {
          this.gridApi.showNoRowsOverlay();
        }
      }
    },
  },
  mounted() {
    this.setYearFilterArray();
    this.columnDefs = [
      {
        headerName: "List Title",
        field: "listTitle",
        sort: "asc",
      },
      {
        headerName: "Supplier Name",
        field: "name",
        suppressSizeToFit: true,
        width: "220",
      },
      {
        headerName: "Membership Listing Date",
        field: "membershipListingDate",
        suppressSizeToFit: true,
        width: "150",
      },
      {
        headerName: "Category",
        field: "category",
        valueFormatter: (params) => {
          let categories = JSON.parse(
            JSON.stringify(
              this.categories.filter((c) =>
                params.data.category.split(",").includes(c.id)
              )
            )
          );
          let categoryString = "";
          let first = true;
          categories.forEach((element) => {
            if (first) {
              categoryString = element.name;
              first = false;
            } else {
              categoryString = `${categoryString}, ${element.name}`;
            }
          });
          return categoryString;
        },
      },
      {
        headerName: "Sub Category",
        field: "subCategory",
        valueFormatter: (params) => {
          let categories = JSON.parse(
            JSON.stringify(
              this.categories.filter((c) =>
                params.data.category.split(",").includes(c.id)
              )
            )
          );
          let subCategories = [];
          let first = true;
          let subCategoryString = "";
          categories.forEach((category) => {
            let subCategory = category.children.filter((c) =>
              params.data.subCategory.split(",").includes(c.id)
            );
            subCategories = subCategories.concat(subCategory);
          });
          subCategories.forEach((subCat) => {
            if (first) {
              subCategoryString = subCat.name;
              first = false;
            } else {
              subCategoryString = `${subCategoryString}, ${subCat.name}`;
            }
          });
          return subCategoryString;
        },
      },
      {
        headerName: "Owners Contact Person",
        field: "ownerContactPerson",
      },
      {
        headerName: "Office Location",
        field: "locations",
      },
      {
        headerName: "Can Service",
        field: "canService",
      },
      {
        headerName: "Status",
        field: "status",
      },
    ];
    if (this.business_id != undefined) {
      this.gridApi.showLoadingOverlay();

      this.$store
        .dispatch("leads/loadLeadForGridData", this.business_id)
        .then(() => {
          this.setGridData(this.leadForData);
        });
    } else {
      if (this.gridApi != null) {
        this.gridApi.showNoRowsOverlay();
      }
    }
  },
  methods: {
    setYearFilterArray() {
      let year = new Date().getFullYear();
      for (let i = year; i >= 2018; i--) {
        this.yearFilterArray.push(i);
      }
    },
    // AG GRID
    resetFilters() {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
    },
    updateFilter() {
      this.gridApi.onFilterChanged();
    },
    isExternalFilterPresent() {
      return true;
    },
    doesExternalFilterPass(node) {
      let passed = 0;

      //Membership Year Filter
      if (
        this.agGridFilter.membershipYearFilter == "All" ||
        moment
          .utc(node.data.membershipListingDate)
          .local()
          .format("YYYY") == this.agGridFilter.membershipYearFilter
      ) {
        passed += 1;
      }

      // Status Filter
      if (
        this.agGridFilter.statusFilter.includes(node.data.status) ||
        this.agGridFilter.statusFilter.length == 0
      ) {
        passed += 1;
      }

      if (
        !this.agGridFilter.statusFilter.includes("Admin") &&
        node.data.id == 32
      ) {
        passed -= 1;
      }

      if (
        (this.agGridFilter.statusFilter.includes("Admin") &&
          node.data.id == 32 &&
          !this.agGridFilter.statusFilter.includes("Approved & Live")) ||
        (this.agGridFilter.statusFilter.length == 0 && node.data.id == 32)
      ) {
        passed += 1;
      }

      // Category Filter
      if (
        this.agGridFilter.categoryFilter.length != 0 &&
        this.agGridFilter.categoryFilter != "0"
      ) {
        let foundMatch = node.data.category
          .split(",")
          .find((val) => this.agGridFilter.categoryFilter.includes(val));
        if (typeof foundMatch != "undefined") {
          passed += 1;
        }
      } else {
        passed += 1;
      }

      // Category Filter
      if (
        this.agGridFilter.subCategoryFilter.length != 0 &&
        this.agGridFilter.subCategoryFilter != "0"
      ) {
        let foundMatch = node.data.subCategory
          .split(",")
          .find((val) => this.agGridFilter.subCategoryFilter.includes(val));
        if (typeof foundMatch != "undefined") {
          passed += 1;
        }
      } else {
        passed += 1;
      }

      if (passed == 4) {
        return true;
      } else {
        return false;
      }
    },

    setGridData(data) {
      const rowData = data;
      this.gridApi.setRowData(rowData);
      // this.gridApi.setFilterModel(this.filterModel);
      setTimeout(() => {
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function(column) {
          if (column.colDef.suppressSizeToFit != true) {
            allColumnIds.push(column.colId);
          }
        });

        // this.gridApi.sizeColumnsToFit();
        this.columnApi.autoSizeColumns(allColumnIds, false);
        this.gridApi.hideOverlay();
      }, 50);
    },
    onQuickFilterChanged() {
      clearTimeout(this.searchDebounce);

      this.searchDebounce = setTimeout(() => {
        this.gridApi.setQuickFilter(this.search);
      }, 150);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      if (
        typeof this.leadForData != "undefined" &&
        this.leadForData.length != 0
      ) {
        this.setGridData(this.leadForData);
      } else {
        this.gridApi.showNoRowsOverlay();
      }
    },
    // END OF AGGRID METHODS
    createLinks() {
      this.createLeadsLoading = true;
      let rows = this.gridApi.getSelectedRows();
      let leads = [];
      rows.forEach((row) => {
        let lead = {};

        lead.callRailPhone = row.callRailPhone;
        lead.urlKeyword = row.urlKeyword;
        lead.listTitle = row.listTitle;
        lead.leadSummary = row.leadSummary;
        lead.opportunitySummary = row.specificBenefits;
        lead.business_id = this.business_id;
        lead.leadFromName = this.lockedData.leadFromName;
        lead.leadFromPhone = this.lockedData.leadFromPhone;
        lead.leadFromEmail = this.lockedData.leadFromEmail;
        lead.impactBuyerType = this.lockedData.impactBuyerType;
        lead.leadFromType = this.lockedData.impactBuyerType;
        lead.leadFor_business_id = row.id;
        leads.push(lead);
      });
      this.$store.dispatch("leads/createMultipleLeads", leads).then(() => {
        this.createLeadsLoading = false;
        this.gridApi.showLoadingOverlay();
        this.$store
          .dispatch("leads/loadLeadForGridData", this.business_id)
          .then(() => {
            this.setGridData(this.leadForData);
          });
        this.$store.dispatch("leads/loadAll");
      });
    },
  },
};
</script>

<style>
.croppa-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.icon-remove {
  position: absolute;
  top: 5px !important;
  right: -35px !important;
}

.croppa-container canvas {
  border: 1px solid;
}
</style>
